<template>
  <div
    :style="{
      background: activityLotteryList.themeColor,
      padding: '0 0 12px',
      'margin-bottom': '-20%',
    }"
  >
    <div style="margin-bottom: 20px">
      <!-- 可配置图片 -->
      <img
        :src="getProductImageUrl(activityLotteryList.topImg, 400)"
        width="100%"
      />
      <!-- <img src="@/assets/image/active/activeFor1111/top.jpg" /> -->
    </div>

    <div class="my-code">
      <img src="@/assets/image/active/activeFor828/我的抽奖码标题@2x.png" />
      <div class="my-code-title">{{ $t("我的抽獎碼") }}</div>
    </div>
    <div style="padding: 0 5.33%">
      <div class="container">
        <div class="left-top"></div>
        <div class="left-bg"></div>
        <div>
          <div v-if="loading" class="loading-container">
            <div class="loading-text">{{ $t("載入中...") }}</div>
          </div>
          <div
            v-else-if="drawList.length > 0"
            style="height: 180px; overflow: auto"
          >
            <div v-for="(item, index) in drawList" class="numList" :key="index">
              <div class="listInde">{{ index + 1 }}.</div>
              <div :class="item.win ? 'num numA' : 'num'">
                <div>{{ item.nu.substring(0, 1) }}</div>
                <div>{{ item.nu.substring(1, 2) }}</div>
                <div>{{ item.nu.substring(2, 3) }}</div>
                <div>{{ item.nu.substring(3, 4) }}</div>
                <div>{{ item.nu.substring(4, 5) }}</div>
              </div>
            </div>
          </div>
          <div v-else>
            <!-- src="@/assets/image/active/activeFor1111/code_bg.png" -->
            <img style="width: 100%; margin: 0 auto" />
            <div class="codePire">
              {{ $t("抱歉你的消費金額還未滿 ")
              }}{{ formatNumber1(activityLotteryList.lotteryBase) }}{{ $t("，快去搶購吧~") }}
            </div>
          </div>
        </div>
        <div class="right-bg"></div>
      </div>
    </div>
    <div>
      <img src="@/assets/image/active/activeFor828/btn上@2x.png" alt />
      <div
        class="go-shopping"
        v-if="isActivityActive && activityLotteryList.shoppingButton === '1'"
      >
        <img
          style
          @click="goto"
          src="@/assets/image/active/activeFor828/btn@2x_1.png"
        />
        <div class="go-shopping-text" @click="openShopping">{{ $t("前往購物") }}</div>
      </div>
      <!-- 2 活动已结束 -->
      <div class="go-shopping" v-if="isActivityFinished">
        <img src="@/assets/image/active/activeFor828/btn@2x.png" />
        <div class="go-shopping-text" style="width: 107%">
          {{ $t("活動已結束") }}
        </div>
      </div>
      <!-- 0 活动未开始 -->
      <!-- <div class="go-shopping" v-if="isActivityNotStarted">
        <img src="@/assets/image/active/activeFor828/btn@2x.png" />
        <div class="go-shopping-text" style="width: 107%">
          {{ $t("活動未開始") }}
        </div>
      </div> -->
      <div class="go-shopping-long" v-if="isActivityNotStarted">
        <!-- <img src="@/assets/image/active/activeFor828/btn@2x.png" /> -->
        <div class="go-shopping-long-text">
          {{ $t("活動未開始") }}
        </div>
      </div>
      <img src="@/assets/image/active/activeFor828/btn下@2x.png" alt />
    </div>
    <div style="margin-bottom: 20px">
      <div
        class="Synthesize-codes"
        v-if="activityLotteryList.compoundButton === '1'"
      >
        <div class="Synthesize-top">
          <div class="title">{{ activityLotteryList.title }}</div>
          <div class="describe">{{ activityLotteryList.activityExplain }}</div>
          <img src="@/assets/image/active/activeFor828/bg_标题@2x.png" alt />
        </div>
        <div>
          <div class="Synthesize-content">
            <img src="@/assets/image/active/activeFor828/bg奖品@2x.png" alt />
            <!-- todo 后台配置的图片 -->
            <img
              class="prize"
              :src="getProductImageUrl(activityLotteryList.activityImg, 400)"
              alt
            />
            <div class="goSynthesize">
              <div class="goSynthesize-img">
                <img
                  v-if="isActivityActive"
                  style="height: 19.4667vw"
                  src="@/assets/image/active/activeFor828/bg-去下单@2x.png"
                  alt
                />
                <div
                  v-if="isActivityFinished || isActivityNotStarted"
                  class="go-view"
                >
                  <img
                    src="@/assets/image/active/activeFor828/goview.png"
                    @click="gotoSynthesize"
                    alt
                  />
                  <div class="go-view-text">{{ $t("去睇") }}</div>
                </div>
                <img
                  v-else
                  class="gotupgif"
                  src="@/assets/image/active/activeFor828/gotoup.gif"
                  @click="gotoSynthesize"
                  alt
                />
              </div>
              <div class="goSynthesize-img" v-if="isActivityActive">
                <img
                  src="@/assets/image/active/activeFor828/bg-去下单@2x.png"
                  alt
                />
                <p
                  style="
                    text-wrap: balance;
                    width: 100%;
                    padding: 0 20px;
                    position: absolute;
                    z-index: 8;
                  "
                  v-if="canSynthesize"
                >
                  还差
                  <span style="color: #e12426">{{ activityList.differ }}</span
                  >{{ $t("個抽獎碼可再升級1個生日願望清單抽獎碼") }}
                  <span style="color: #e12426" @click="goto">{{
                    $t("去下單>")
                  }}</span>
                </p>
                <p v-else>
                  <span>{{ $t("獲取更多抽獎碼進行升級") }}</span>
                  <span style="color: #e12426" @click="goto">{{
                    $t("去下單>")
                  }}</span>
                </p>
              </div>
              <div class="goSynthesize-img">
                <img
                  src="@/assets/image/active/activeFor828/bg-圆角底部@2x.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        :style="{ color: activityLotteryList.titleColor }"
        class="raffleRules"
      >
        {{ $t("抽獎規則") }}
      </div>
      <img
        :src="getProductImageUrl(activityLotteryList.raffleRulesImg, 400)"
        width="100%"
      />
    </div>
    <div>
      <div
        :style="{ color: activityLotteryList.titleColor, 'margin-top': '30px' }"
        class="raffleRules"
      >
        {{ $t("活動獎品") }}
      </div>
      <div v-for="(item, index) in activityLotteryList.prizeImg" :key="index">
        <img :src="getProductImageUrl(item, 400)" width="100%" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { getSyntheticDraw } from "@/api/active";
import mixins from "@/utils/mixins";
import { getToken } from "@/utils/token";
import { getCurrencyByUserRegion } from "@/utils/util.js"

export default {
  data() {
    return {
      imgList: [],
      activityList: {},
      loading: false,
      currency: 'HK$'
    };
  },
  mixins: [mixins],
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getSyntheticDraw({ id: this.activityLotteryId });
        if (res.resultID === 1200) {
          this.activityList = res.data;
        }
      } catch (error) {
        console.error("获取合成抽奖数据失败:", error);
        this.$toast(this.$t("獲取數據失敗，請重試"));
      } finally {
        this.loading = false;
      }
    },
    openShopping() {
      this.$router.push("/");
    },
    gotoSynthesize() {
      if (!this.activityLotteryList.compoundLink) {
        this.$toast(this.$t("鏈接配置錯誤"));
        return;
      }
      this.$router.push(
        this.activityLotteryList.compoundLink +
          `?id=${this.activityLotteryList.id}` +
          `&isfinish=${this.activityLotteryList.isfinish}`
      );
    },
    goto() {
      const func1 = () => {
        mmm.goHome();
      };
      const func2 = () => {
        window.webkit.messageHandlers.goHome.postMessage("a");
      };
      const func3 = () => {
        this.$router.push("/");
      };
      const func4 = () => {
        wx.miniProgram.switchTab({
          url: "/pages/home/index",
        });
      };
      this.excFunc1(func1, func2, func3, func4);
    },
  },
  async mounted() {
    console.log("this.drawList", this.drawList);
    const token = getToken();
    if (!token) {
      const func1 = () => {
        mmm.toLogin();
      };
      const func2 = () => {
        window.webkit.messageHandlers.toLogin.postMessage("jj");
      };
      const func3 = () => {
        this.$router.push({
          path:
            "/login?returnUrl=" +
            encodeURIComponent(
              window.location.pathname + window.location.search
            ),
        });
      };
      const func4 = () => {
        wx.miniProgram.navigateTo({
          url: "/pages/loginChoice/index",
        });
      };
      this.excFunc1(func1, func2, func3, func4);
    } else {
      await this.$store.dispatch("active/getActivityLottery");
      this.$store.dispatch("active/getPresentDraw", {
        id: this.activityLotteryId,
      });
      document.title = this.activityLotteryList.activityName;
      if (
        this.activityLotteryList.isfinish === "2" ||
        this.activityLotteryList.isfinish === "0"
      ) {
        return;
      } else {
        // this.getList();
      }
    }
    // 根据用户地区获取正确的货币符号
    this.currency = getCurrencyByUserRegion()
  },
  beforeUnmount() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color: #f7f8fb;");
  },
  computed: {
    ...mapGetters("active", [
      "drawList",
      "activityLotteryList",
      "activityLotteryId",
    ]),
    // 活动是否进行中
    isActivityActive() {
      return this.activityLotteryList.isfinish === "1";
    },
    // 活动是否已结束
    isActivityFinished() {
      return this.activityLotteryList.isfinish === "2";
    },
    // 活动是否未开始
    isActivityNotStarted() {
      return this.activityLotteryList.isfinish === "0";
    },
    // 是否可以合成
    canSynthesize() {
      return (
        this.activityList.differ !== 0 &&
        !(
          this.drawList.length > this.activityLotteryList.compoundBase &&
          this.activityList.canSyntheticCode >=
            this.activityLotteryList.compoundBase
        )
      );
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;

  background: #fff !important;
}
.container > div {
  padding: 0% 6%;
  color: #fff;
}
.container .left-bg,
.container .right-bg {
  position: absolute;
  bottom: 0px;
  width: 2.6888vw;
  height: 50%;
  background-color: #deaf45;
  padding: 0;
}
.container .left-bg {
  left: -3%;
  border-top-left-radius: 6px;
}
.container .right-bg {
  right: -3%;
  border-top-right-radius: 6px;
}
.listInde {
  background: #c61a1a;
  border-radius: 30px 0px 0px 30px;
  height: 32px;
  line-height: 31px;
  font-size: 24px;
  padding-left: 10px;
  width: 19%;
  border-right: 1px solid #fff;
}
.my-code {
  position: relative;
}
.my-code-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 66.67%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #333;
  font-weight: bold;
}
.numList {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px;
}
.num {
  display: flex;
  padding-left: 43px;
  align-items: center;
  width: 88%;
  font-weight: 400;
  background: linear-gradient(180deg, #c42829 0%, #fd2123 100%);
  border-radius: 0px 30px 30px 0px;
}
.num div {
  margin-right: 23px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 24px;
}
img {
  width: 100%;
  display: block;
}
.go-shopping {
  position: relative;
}
.go-shopping-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
}
.go-shopping-long{
  /* width: 100%; */
  background: linear-gradient( 83deg, #F5E4B1 0%, #EEC15D 100%);
  width: 94.5%;
  margin-left: 2.75%;
  display: flex;
  justify-content: center;
}
.go-shopping-long-text{
    width: 75%;
    background: linear-gradient(90deg, #B8B8B8 0%, #CDCDCD 100%);
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
}
.raffleRules {
  text-align: center;
  font-size: 28px;
  font-weight: 800;
  line-height: 25px;
  margin-bottom: 30px;
}
.codePire {
  font-size: 12px;
  color: #ff3420;
  text-align: center;
  padding-bottom: 0.4rem;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
}
.loading-text {
  font-size: 14px;
  color: #666;
}
.Synthesize-content {
  position: relative;
}
.Synthesize-content .prize {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 73.3333vw;
  height: 87.4667vw;
}
.goSynthesize .goSynthesize-img {
  position: relative;
}
.goSynthesize .goSynthesize-img p {
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
}
.go-view {
  position: relative;
}
.go-view-text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
}
.Synthesize-top {
  position: relative;
}
.Synthesize-top .title {
  position: absolute;
  bottom: 33%;
  text-align: center;
  width: 100%;
  font-size: 6.6667vw;
  font-family: OPPOSans-Heavy, OPPOSans;
  font-weight: 800;
  color: #43403d;
}
.Synthesize-top .describe {
  position: absolute;
  bottom: 14%;
  width: 100%;
  text-align: center;
  font-size: 3.4667vw;
  font-family: OPPOSans-Heavy, OPPOSans;
  color: #43403d;
}
.gotupgif {
  position: absolute;
  z-index: 1;
  top: 0;
}
/* .num div:first-child{
        background: url("@/assets/image/active/active/iphone4@2x.png");
        background-size: cover;
        color: #fff    }
    .num div:nth-child(2), .num div:nth-child(3), .num div:nth-child(4){
        background: url("@/assets/image/active/active/iphone3@2x.png");
        background-size: cover;
        color: #666
    }
    .numA div:nth-child(1),.numA div:nth-child(2), .numA div:nth-child(3), .numA div:nth-child(4){
        background: url("@/assets/image/active/active/iphone2@2x.png");
        background-size: cover;
        color: #fff
    } */
/* .numA{
        position: relative;
    }
    .numA::after{
        content: '';
        position: absolute;
        right: 10px;
        top: 0;
        width: 20px;
        height: 30px;
        background: url("@/assets/image/active/active/iphone1@2x.png");
        background-size: cover;
    } */
</style>
